(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsDemiWaterViewModel', facilityDetailsDemiWaterViewModelFactory);

  /** @ngInject */
  function facilityDetailsDemiWaterViewModelFactory(demiWaterSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsDemiWaterViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_DEMIN_VODE] = 'highFloat';
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_DEMIN_VODE] = 'lowFloat';
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_RAD] = 'motor';
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_GRE_MZS] = 'motorError';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(demiWaterSubsystemUtils.getDemiWaterSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsDemiWaterViewModel.prototype.destroy = function () {

    };

    FacilityDetailsDemiWaterViewModel.prototype.refresh = function (demiWaterPointJson) {
      this.pointId = demiWaterPointJson.id;
      this.name = demiWaterPointJson.name;
      this.pointType = demiWaterPointJson.pointType;
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_DEMIN_VODE));
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_DEMIN_VODE));
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_RAD));
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_GRE_MZS));
    };

    FacilityDetailsDemiWaterViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsDemiWaterViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();
